<form [formGroup]="dividendFg">
    <div>
        <div class="row">
            <div class="col col-1">
                <p>Op welke datum is het dividend beschikbaar gesteld?</p>
            </div>
            <div class="col-2">
                <snelstart-ui-date-form-control formControlName="datumBeschikbaarstelling"
                                                id="datumBeschikbaarstelling"
                                                label=""
                                                class="custom-input-150"
                                                (change)="saveForm()"
                >
                </snelstart-ui-date-form-control>
            </div>
            <div class="col-4"></div>
        </div>
    </div>
</form>

<form [formGroup]="algemeenFg">
    <div>
        <div class="row">
            <div class="col col-1">
                <p>Wat is het volgnummer van deze aangifte? (Maximaal 999).</p>
            </div>
            <div class="col-2">
                <snelstart-ui-number-form-control formControlName="volgnummer"
                                                  align="right"
                                                  prefix=""
                                                  class="custom-input-150"
                                                  [maxValue]="999"
                                                  [minValue]="1"
                                                  [showAllDecimals]="false"
                                                  (change)="this.saveForm()"
                >
                </snelstart-ui-number-form-control>
            </div>
            <div class="col-4"></div>

        </div>
    </div>
    <div>
        <div class="row">
            <div class="col col-1">
                <p>Wordt er dividend uitgekeerd aan buitenlandse aandeelhouders?</p>
            </div>
            <div class="col-2">
                <snelstart-ui-select-form-control formControlName="hasForeignShareholders"
                                                  id="hasForeignShareholders"
                                                  [options]="optionsJaNeeBuitenland"
                                                  [required]=true
                                                  class="custom-input-150"
                                                  (change)="this.saveForm()"
                >
                </snelstart-ui-select-form-control>
            </div>
            <div class="col-4"></div>

        </div>
    </div>
    <div>
        <div class="row">
            <div class="col col-1">
                <p>Is een afdrachtvermindering van art. 11 of 12 Wet DB (buitenlandse bronheffing) van toepassing?</p>
            </div>
            <div class="col-2">
                <snelstart-ui-select-form-control formControlName="hasAfdrachtvermindering"
                                                  id="hasAfdrachtvermindering"
                                                  [options]="optionsJaNee"
                                                  [required]=true
                                                  class="custom-input-150"
                                                  (change)="this.saveForm()"
                >
                </snelstart-ui-select-form-control>
            </div>
            <div class="col-4"></div>
        </div>
    </div>
</form>
